module.exports = __webpack_public_path__ + "img/GH-corporate-001.d3246929.png";